import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/configurator';
import { post, get, del } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

/** Получение списка привязанных к складу и операции атрибутов */
export function* getConfigureStockAttributes({ payload }) {
  try {
    const request = yield call(
      get,
      `/settings/plantconfigattribs/list?id=${payload.plantConfigOperationsId}`,
    );
    yield put(action.getConfigureStockAttributesSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getConfigureStockAttributesFail());
  }
}

/** Получение списка всех атрибутов */
export function* getAllAttributes({ payload }) {
  try {
    const request = yield call(
      get,
      // `/settings/plantconfigattribs/listall?id=${payload.plantConfigOperationsId}`,
      '/settings/attribscatalog/listall'
    );
    yield put(action.getAllAttributesSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getAllAttributesFail());
  }
}

/** Получить список типов наследования */
export function* getInheritTypes({ payload }) {
  try {
    const request = yield call(
      get,
      '/settings/plantconfigattribs/listinherittype',
      payload
    );
    yield put(action.getInheritTypesSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getInheritTypesFail());
  }
}

/** Добавление атрибутов из списка наследуемых и привязка к операции и складу */
export function* saveConfigureStockAttributes({ payload }) {
  try {
    const request = yield call(post, '/settings/plantconfigattribs/all', payload);
    yield put(action.saveConfigureStockAttributesSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.saveConfigureStockAttributesFail());
  }
}

/** Функция переключатель вкл/выкл операции для склада */
export function* saveAvailableOperations({ payload }) {
  try {
    const request = yield call(
      post,
      '/settings/plantconfigoperations/',
      payload
    );
    yield put(action.saveAvailableOperationsSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.saveAvailableOperationsFail());
  }
}

/** Создание новой операции (в текущей реализации не нужно) */
export function* createOperation({ payload }) {
  // payload = { code: number, title: string}
  try {
    const request = yield call(post, '/settings/operationtype/', payload);
    yield call(post, '/settings/plantconfigoperations/', {
      operationTypeId: request,
      plantConfigId: payload.plantId,
      isActive: true
    });
    yield put(action.createOperationSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.createOperationFail());
  }
}

/** Получение включенных для склада операций */
export function* getAvailableOperations({ payload }) {
  try {
    const request = yield call(
      get,
      `/settings/plantconfigoperations/list?plantId=${payload.plantId}`
    );
    yield put(action.getAvailableOperationsSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getAvailableOperationsFail());
  }
}

/** Получение всех операций с флагами включения */
export function* getAllOperations({ payload }) {
  try {
    const request = yield call(
      get,
      `/settings/plantconfigoperations/listforconfigurator?plantId=${payload.plantId}`
    );
    yield put(action.getAllOperationsSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getAllOperationsFail());
  }
}

/** Удаление атрибута из списка привязанных к операции и складу */
export function* delConfigureStockAttribute({ payload }) {
  try {
    const request = yield call(
      del,
      `/settings/plantconfigattribs/${payload.plantOperationAttribsId}`,
    );
    yield put(action.delConfigureStockAttributeSuccess(request));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.delConfigureStockAttributeFail());
  }
}
